
import { BookingDetails, BookingList } from "../../../pages";
import superadminRoutesMap from "../../../routeControl/superadminRoutes";

export default function route() {
  return [
    {
      path: superadminRoutesMap.BOOKLIST.path,
      name: "Booking List",
      key: superadminRoutesMap.BOOKLIST.path,
      private: true,
      belongsToSidebar: true,
      icon: "tripon-booking",
      element: <BookingList />,
    },
    {
      path: `${superadminRoutesMap.BOOKDETAILS.path}/:id`,
      name: "Booking Details",
      key: `${superadminRoutesMap.BOOKDETAILS.path}/:id`,
      private: true,
      belongsToSidebar: false,
      element: <BookingDetails />,
    },
  ];
}
